import HomePage from "./HomePage"
import NotFoundPage from "./NotFoundPage"
import AppSigninPage from "./AppSigninPage"
import Account from "../Account"
import SnapViewer from "../SnapViewer"
import Pricing from "./Pricing"
import FeaturesPage from "./FeaturesPage"
import PaymentResultPage from "./PaymentResultPage"
import PrivacyPolicyPage from "./PrivacyPolicyPage"
import TermsOfUsePage from "./TermsOfUsePage"
import BlogHome from "../Blog/home"
import BlogPostPage from "./BlogPostPage"

// Register all site page routes at once using an object
export default {
  "/": HomePage,
  "/404": NotFoundPage,
  // Sign-in page for the AldooSnap mac app WebView dialog
  "/app-signin": AppSigninPage,
  "/account": Account,
  "/account/*": Account,
  "/pricing": Pricing,
  "/features": FeaturesPage,
  "/privacy-policy": PrivacyPolicyPage,
  "/terms-of-use": TermsOfUsePage,
  "/blog": BlogHome,
  "/blog/*": BlogPostPage,
  // Landing page for Stripe redirect-based payment methods
  "/payment-result": PaymentResultPage,
  // Public capture viewer — short share links (snap.aldoo.com/v/{hash})
  "/v/*": SnapViewer,
}

// Per-route options. noLanguagePrefix: true — the /v/ prefix would otherwise
// be parsed as a two-letter language code and break route resolution.
export const routeOptions = {
  "/v/*": { noLanguagePrefix: true },
}
